import { Select } from '@mantine/core'
import type { TValuesCurrentPoints } from 'App/Map/types'
import { translate } from 'i18n/i18n'
import { useEffect } from 'react'
import { SharedSettings } from 'settings/SharedSettings'
import { mapControlsStore } from 'stores/mapControlsStore/mapControlsStore'
import { MAP_VISUAL } from 'stores/mapControlsStore/types'
import { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { mantineSelectSearchFilterProp } from 'utils/mantineSelectSearchFilterProp'
import { useIsWideScreen } from 'utils/useIsWideScreen'
import { useSelectClickToggle } from 'utils/useSelectClickToggle'

const updateMapVisuals = (newValueType: TValuesCurrentPoints) => {
  mapControlsStore.setState((s) => ({
    ...s,
    mapVisualValueGroup: {
      ...s.mapVisualValueGroup,
      [MAP_VISUAL.POINT]: {
        ...s.mapVisualValueGroup[MAP_VISUAL.POINT],
        irrigation_activity_flow_meters: {
          ...(s.mapVisualValueGroup[MAP_VISUAL.POINT].irrigation_activity_flow_meters ?? {
            mItem: 'M_InBlockPoint',
          }),
          valueType: newValueType,
        },
      },
    },
  }))
}

export const IrrigationFlowMeterSecondaryDropdown = () => {
  const isWideScreen = useIsWideScreen()
  const selectClickToggle = useSelectClickToggle()
  const primaryValueGroup = selectedValueGroupsStore.useSelector((s) => s.primaryValueGroup)

  const secondaryValueType = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup?.[MAP_VISUAL.POINT]?.irrigation_activity_flow_meters?.valueType,
  )

  useEffect(() => {
    if (primaryValueGroup === 'irrigation_activity_flow_meters' && !secondaryValueType) {
      updateMapVisuals('irrigationActivity_today_cumulativeFlowMeter_gallons' as TValuesCurrentPoints)
    }
  }, [primaryValueGroup])

  const data = [
    {
      label: translate.phrases.banyanApp('Cumulative Flow Today'),
      value: 'irrigationActivity_today_cumulativeFlowMeter_gallons' as TValuesCurrentPoints,
    },
    {
      label: translate.phrases.templates('{{labelA}} ({{labelB}})', {
        labelA: translate.phrases.banyanApp('Cumulative Flow'),
        labelB: translate.phrases.banyanApp('Prev {{count}} Days', { count: 7 }),
      }),
      value: 'irrigationActivity_prev7Days_cumulativeFlowMeter_gallons' as TValuesCurrentPoints,
    },
    {
      label: translate.phrases.templates('{{labelA}} ({{labelB}})', {
        labelA: translate.phrases.banyanApp('Cumulative Flow'),
        labelB: translate.phrases.banyanApp('Season'),
      }),
      value: 'irrigationActivity_season_cumulativeFlowMeter_gallons' as TValuesCurrentPoints,
    },
    {
      label: translate.phrases.templates('{{labelA}} ({{labelB}})', {
        labelA: translate.phrases.banyanApp('Cumulative Flow'),
        labelB: translate.phrases.banyanApp('YTD'),
      }),
      value: 'irrigationActivity_YTD_cumulativeFlowMeter_gallons' as TValuesCurrentPoints,
    },
  ]

  const selectedValueType = mapControlsStore.useSelector(
    (s) => s.mapVisualValueGroup?.[MAP_VISUAL.POINT]?.irrigation_activity_flow_meters?.valueType,
  )

  return (
    <div css={{ display: 'flex', flexDirection: 'column' }}>
      <Select
        {...selectClickToggle}
        data={data}
        filter={mantineSelectSearchFilterProp}
        onChange={(newValueType) => {
          if (newValueType) updateMapVisuals(newValueType as TValuesCurrentPoints)
        }}
        styles={SharedSettings.MANTINE_SELECT_RIGHT_ICON_CHANGER}
        searchable={isWideScreen}
        value={selectedValueType}
        comboboxProps={{ withinPortal: true }}
      />
    </div>
  )
}
